const ChargeBanner = () => {
  return (
    <div className="ac-charge ch-rounded--sm ch-overflow--hidden ch-display--flex ch-mb--4">
      <div className="ac-charge__icon--left sm:ch-display--none"></div>
      <div className="ac-charge__text ch-pa--1 ch-color--white sm:ch-text--center ch-flex--auto">
        <span className="ac-charge__text--green ch-fw--500">
          Ultra-rapid charging
        </span>{' '}
        at just 55p/kWh, plus free coffee while you charge!{' '}
        <a
          className="ch-fw--500 ac-charge__link"
          href="/charge"
          target="_blank"
        >
          Learn more
        </a>
      </div>
      <div className="ac-charge__icon--right ch-display--none sm:ch-display--block"></div>
    </div>
  );
};

export default ChargeBanner;
